<template>
  <div class="SessionList">
    <div class="sessions">
      <input
        v-if="serverOrigin"
        class="search-box"
        placeholder="Session ID"
        v-model="sessionFilter"
        @keydown.enter="goToSession"
        type="text">

      <router-link
        v-if="serverOrigin"
        :to="{ path: `/origin/${serverOrigin}` }"
        class="session">
          All
      </router-link>

      <router-link
        v-for="session in visibleSessions"
        :to="{ path: `/origin/${serverOrigin}/session/${session}` }"
        :key="session"
        class="session">
          Session #{{session}}
      </router-link>

    </div>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'

export default {
  name: 'SessionList',
  props: {
    userMail: String,
    serverOrigin: String
  },
  data () {
    return {
      sessionFilter: ''
    }
  },
  methods: {
    goToSession (e) {
      let sessionId = e.target.value.trim()

      if (sessionId) {
        this.$router.push(
          {path:
            `/origin/${this.serverOrigin}/session/${sessionId}`})
      }
    }
  },
  computed: {
    visibleSessions () {
      let sessions = this.serverOrigin
        ? this.sessionsByOrigin(this.serverOrigin)
        : this.userMail
          ? this.sessionsByUser(this.userMail)
          : []

      return this.sessionFilter.length > 0
        ? sessions
          .map(x => x.toString())
          .filter(x =>
            x.includes(this.sessionFilter))
        : sessions
    },
    ...mapGetters([
      'sessionsByUser',
      'sessionsByOrigin'
    ]),
    ...mapState([
      'sessions'
    ])
  }
}
</script>

<style scoped>

.sessions {
  position: sticky;
  top: 30px;
}

.session {
  text-decoration: none;
  display: block;
  padding: 15px;
  border-left: 3px solid transparent;
  color: inherit;
  transition: background-color 0.3s cubic-bezier(.25,.8,.25,1);
}

.session:hover {
  background-color: #EEEEEE;
  border-left: 3px solid #BDBDBD;
}

.session.router-link-exact-active {
  border-left: 3px solid #757575;
}

</style>
